import { FC } from "react";
import { JourneyDerivedStatus } from "../../types/journey";
import {
  mapJourneyStatusToDisplay,
  getStatusBadgeClasses,
} from "../../utils/journeyStatusUtils";

interface StatusBadgeProps {
  status: JourneyDerivedStatus;
}

/**
 * Status badge component for journey cards
 * Displays a color-coded badge based on journey status
 */
const StatusBadge: FC<StatusBadgeProps> = ({ status }) => {
  // Get the display status and styling using our utility functions
  const displayStatus = mapJourneyStatusToDisplay(status);
  const styleClasses = getStatusBadgeClasses(displayStatus);

  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${styleClasses.bg} ${styleClasses.text}`}
    >
      {displayStatus}
    </span>
  );
};

export default StatusBadge;
